import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'vietnam_fac_contribution_for_social_health_and_unemployment_ins'

export const dataPointDefinition = {
  retracedId: 'vietnam_fac_contribution_for_social_health_and_unemployment_ins',
  name: 'Vietnam: Facility contribution for social, health and unemployment insurance for workers not covered by compulsory social insurance',
  description:
    'This question is specific to Vietnam only. Please consult the Law Overlay for more information on applicable legal requirements.\r\r\n\r\r\nAnswer Not Applicable if all workers are covered by compulsory social insurance.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'X',
      key: 'TRUE',
      slcpIndex: 1,
      slcpOptionName: 'xna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 2,
      slcpOptionName: 'xna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['TRUE', 'NOT_APPLICABLE'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-116x',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9310,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
